module.exports = __webpack_public_path__ + "static/media/icon_mail.4aa072c9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/about/icon_mail.svg
// module id = 154
// module chunks = 0